// Enforces per-product max quantity rules based on product tags.
// Intercepts add-to-cart AND cart change requests.

(function () {
  var TAG_RULES = {
    'max-2': 2
  };

  var CONTACT_EMAIL = 'info@cape.co';
  var ERROR_MESSAGE_TEMPLATE =
    'This item is limited to {max} per order. For enterprise sales, please contact ' + CONTACT_EMAIL;

  var tagCache = {};
  var variantHandleCache = {};

  function buildErrorMessage(max) {
    return ERROR_MESSAGE_TEMPLATE.replace('{max}', max);
  }

  function getProductTags(handle) {
    if (tagCache[handle]) return Promise.resolve(tagCache[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        tagCache[handle] = p.tags || [];
        if (p.variants) {
          p.variants.forEach(function (v) {
            variantHandleCache[v.id] = handle;
          });
        }
        return tagCache[handle];
      })
      .catch(function () { return []; });
  }

  function getMaxForTags(tags) {
    var lowest = null;
    tags.forEach(function (tag) {
      if (TAG_RULES[tag] != null) {
        if (lowest == null || TAG_RULES[tag] < lowest) {
          lowest = TAG_RULES[tag];
        }
      }
    });
    return lowest;
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function getHandleFromPage() {
    var el = document.querySelector('[data-product-handle], product-info[data-product-handle]');
    if (el && el.getAttribute('data-product-handle')) {
      return el.getAttribute('data-product-handle');
    }
    var form = document.querySelector('form[action*="/cart/add"] [name="product-handle"]');
    if (form && form.value) return form.value;
    var match = window.location.pathname.match(/\/products\/([^\/\?]+)/);
    if (match) return match[1];
    return null;
  }

  function resolveHandle(variantId) {
    if (variantHandleCache[variantId]) {
      return Promise.resolve(variantHandleCache[variantId]);
    }
    var pageHandle = getHandleFromPage();
    if (pageHandle) {
      variantHandleCache[variantId] = pageHandle;
      return Promise.resolve(pageHandle);
    }
    return getCart().then(function (cart) {
      var match = cart.items.find(function (i) { return String(i.variant_id) === String(variantId); });
      if (match) {
        variantHandleCache[variantId] = match.handle;
        return match.handle;
      }
      return null;
    });
  }

  function showMessage(max) {
    var existing = document.getElementById('max-qty-message');
    if (existing) existing.remove();

    var banner = document.createElement('div');
    banner.id = 'max-qty-message';
    banner.style.cssText =
      'position: fixed; top: 20px; left: 50%; transform: translateX(-50%);' +
      'background: #b00; color: white; padding: 1rem 1.5rem; border-radius: 4px;' +
      'box-shadow: 0 4px 12px rgba(0,0,0,0.15); z-index: 99999; max-width: 90%;' +
      'font-size: 0.9rem; line-height: 1.4;';
    banner.innerHTML =
      'This item is limited to ' + max + ' per order. For enterprise sales, please contact ' +
      '<a href="mailto:' + CONTACT_EMAIL + '" style="color: white; text-decoration: underline;">' +
      CONTACT_EMAIL + '</a>';

    document.body.appendChild(banner);
    setTimeout(function () {
      if (banner.parentNode) banner.remove();
    }, 6000);
  }

  function checkAdd(variantId, qtyToAdd) {
    return resolveHandle(variantId).then(function (handle) {
      if (!handle) return { allowed: true };
      return Promise.all([getProductTags(handle), getCart()]).then(function (results) {
        var tags = results[0];
        var cart = results[1];
        var max = getMaxForTags(tags);
        if (max == null) return { allowed: true };
        var existing = 0;
        cart.items.forEach(function (item) {
          if (item.handle === handle) existing += item.quantity;
        });
        var newTotal = existing + qtyToAdd;
        if (newTotal <= max) return { allowed: true, max: max };
        return { allowed: false, max: max };
      });
    });
  }

  function checkChange(itemKeyOrId, newQuantity) {
    return getCart().then(function (cart) {
      var targetItem = cart.items.find(function (i) {
        return i.key === itemKeyOrId || String(i.variant_id) === String(itemKeyOrId);
      });
      // Also support line-based identification (1-indexed)
      if (!targetItem && typeof itemKeyOrId === 'number') {
        targetItem = cart.items[itemKeyOrId - 1];
      }
      if (!targetItem) return { allowed: true };

      return getProductTags(targetItem.handle).then(function (tags) {
        var max = getMaxForTags(tags);
        if (max == null) return { allowed: true };

        var otherSameProduct = 0;
        cart.items.forEach(function (item) {
          if (item.handle === targetItem.handle && item.key !== targetItem.key) {
            otherSameProduct += item.quantity;
          }
        });
        var newTotal = otherSameProduct + newQuantity;
        if (newTotal <= max) return { allowed: true, max: max };
        return { allowed: false, max: max };
      });
    });
  }

  function buildErrorResponse(max) {
    return new Response(
      JSON.stringify({
        status: 422,
        message: 'Cart Error',
        description: buildErrorMessage(max),
        errors: buildErrorMessage(max)
      }),
      { status: 422, headers: { 'Content-Type': 'application/json' } }
    );
  }

  function parseBody(body) {
    if (!body) return null;
    try {
      if (body instanceof FormData) {
        var obj = {};
        body.forEach(function (val, key) {
          // Handle nested keys like updates[123]
          var match = key.match(/^([^\[]+)\[([^\]]+)\]$/);
          if (match) {
            if (!obj[match[1]]) obj[match[1]] = {};
            obj[match[1]][match[2]] = val;
          } else {
            obj[key] = val;
          }
        });
        return obj;
      }
      if (typeof body === 'string') {
        try {
          return JSON.parse(body);
        } catch (e) {
          var params = new URLSearchParams(body);
          var obj2 = {};
          params.forEach(function (val, key) {
            var match = key.match(/^([^\[]+)\[([^\]]+)\]$/);
            if (match) {
              if (!obj2[match[1]]) obj2[match[1]] = {};
              obj2[match[1]][match[2]] = val;
            } else {
              obj2[key] = val;
            }
          });
          return obj2;
        }
      }
    } catch (e) {
      return null;
    }
    return null;
  }

  // SINGLE fetch interceptor handling all three endpoints
  var originalFetch = window.fetch;
  window.fetch = function (url, options) {
    var urlStr = typeof url === 'string' ? url : (url && url.url) || '';
    var isAdd = /\/cart\/add(\.js|\.json)?(\?|$)/.test(urlStr);
    var isChange = /\/cart\/change(\.js|\.json)?(\?|$)/.test(urlStr);
    var isUpdate = /\/cart\/update(\.js|\.json)?(\?|$)/.test(urlStr);

    if (!isAdd && !isChange && !isUpdate) {
      return originalFetch.apply(this, arguments);
    }

    var args = arguments;
    var self = this;
    var payload = parseBody(options && options.body);

    if (!payload) return originalFetch.apply(this, arguments);

    if (isAdd) {
      var addVariantId = payload.id || (payload.items && payload.items[0] && payload.items[0].id);
      var addQty = parseInt(payload.quantity, 10) ||
                   (payload.items && payload.items[0] && parseInt(payload.items[0].quantity, 10)) || 1;
      if (!addVariantId) return originalFetch.apply(this, arguments);

      return checkAdd(addVariantId, addQty).then(function (result) {
        if (result.allowed) return originalFetch.apply(self, args);
        showMessage(result.max);
        return buildErrorResponse(result.max);
      });
    }

    if (isChange) {
      var itemId = payload.id || payload.line;
      var qty = parseInt(payload.quantity, 10);
      if (itemId == null || isNaN(qty)) return originalFetch.apply(this, arguments);
      // Convert line strings to numbers for the line-based fallback
      if (typeof itemId === 'string' && /^\d+$/.test(itemId) && payload.line) {
        itemId = parseInt(itemId, 10);
      }
      return checkChange(itemId, qty).then(function (result) {
        if (result.allowed) return originalFetch.apply(self, args);
        showMessage(result.max);
        return buildErrorResponse(result.max);
      });
    }

    if (isUpdate && payload.updates) {
      return getCart().then(function (cart) {
        var updates = payload.updates;
        var checks = [];
        if (Array.isArray(updates)) {
          updates.forEach(function (qty, idx) {
            var item = cart.items[idx];
            if (!item) return;
            checks.push(checkChange(item.key, parseInt(qty, 10) || 0));
          });
        } else {
          Object.keys(updates).forEach(function (variantId) {
            checks.push(checkChange(variantId, parseInt(updates[variantId], 10) || 0));
          });
        }
        return Promise.all(checks).then(function (results) {
          var blocked = results.find(function (r) { return r && !r.allowed; });
          if (!blocked) return originalFetch.apply(self, args);
          showMessage(blocked.max);
          return buildErrorResponse(blocked.max);
        });
      });
    }

    return originalFetch.apply(this, arguments);
  };

  // XHR interceptor for add-to-cart (older code paths)
  var originalOpen = XMLHttpRequest.prototype.open;
  var originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._url = url;
    this._method = method;
    return originalOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    var xhr = this;
    var urlStr = xhr._url || '';
    var isAdd = /\/cart\/add(\.js|\.json)?(\?|$)/.test(urlStr);
    var isChange = /\/cart\/change(\.js|\.json)?(\?|$)/.test(urlStr);
    var isUpdate = /\/cart\/update(\.js|\.json)?(\?|$)/.test(urlStr);

    if (!isAdd && !isChange && !isUpdate) {
      return originalSend.apply(this, arguments);
    }

    var payload = parseBody(body);
    if (!payload) return originalSend.apply(this, arguments);

    var args = arguments;

    function reject(max) {
      showMessage(max);
      var msg = buildErrorMessage(max);
      Object.defineProperty(xhr, 'status', { value: 422, configurable: true });
      Object.defineProperty(xhr, 'responseText', {
        value: JSON.stringify({ status: 422, message: 'Cart Error', description: msg }),
        configurable: true
      });
      if (xhr.onreadystatechange) xhr.onreadystatechange();
      if (xhr.onload) xhr.onload();
    }

    if (isAdd) {
      var variantId = payload.id || (payload.items && payload.items[0] && payload.items[0].id);
      var quantity = parseInt(payload.quantity, 10) ||
                     (payload.items && payload.items[0] && parseInt(payload.items[0].quantity, 10)) || 1;
      if (!variantId) return originalSend.apply(this, arguments);
      checkAdd(variantId, quantity).then(function (result) {
        if (result.allowed) originalSend.apply(xhr, args);
        else reject(result.max);
      });
      return;
    }

    if (isChange) {
      var itemId = payload.id || payload.line;
      var qty = parseInt(payload.quantity, 10);
      if (itemId == null || isNaN(qty)) return originalSend.apply(this, arguments);
      checkChange(itemId, qty).then(function (result) {
        if (result.allowed) originalSend.apply(xhr, args);
        else reject(result.max);
      });
      return;
    }

    return originalSend.apply(this, arguments);
  };
})();